import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useNavigate } from '../../util/router';
import wordmark from '../../assets/images/wordmark.png';
import { MobileMenuButton } from './AppShell';

function PageHeader({ title, subtitle, back = false, actions, children }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/feed');
  };

  const barOnly = !title && !actions && !children;

  return (
    <header
      className={
        barOnly ? 'bg-slate-100 md:hidden' : 'rounded-b-[33px] bg-slate-100 md:rounded-none'
      }
    >
      <div
        className={`mx-auto w-full max-w-[90rem] px-4 pt-4 md:px-8 md:pb-6 md:pt-8 ${
          barOnly ? 'pb-0' : 'pb-4'
        }`}
      >
        <div className="relative flex items-center justify-between md:hidden">
          <div className="w-10">
            {back && (
              <button type="button" onClick={goBack} aria-label="Back" className="p-2">
                <ArrowLeftIcon className="h-6 w-6" />
              </button>
            )}
          </div>
          <Link to="/feed" className="absolute left-1/2 -translate-x-1/2">
            <img src={wordmark} alt="Showrunner" className="w-44" />
          </Link>
          <MobileMenuButton />
        </div>

        {(title || actions) && (
          <div className="mt-4 flex items-end justify-between gap-4 md:mt-0">
            <div className="flex min-w-0 items-center gap-3">
              {back && (
                <button
                  type="button"
                  onClick={goBack}
                  aria-label="Back"
                  className="hidden rounded-lg p-2 hover:bg-black/5 md:block"
                >
                  <ArrowLeftIcon className="h-6 w-6" />
                </button>
              )}
              <div className="min-w-0">
                {title && (
                  <h1 className="truncate text-2xl font-medium text-black md:text-4xl">{title}</h1>
                )}
                {subtitle && <p className="mt-1 text-sm text-black/60 md:text-base">{subtitle}</p>}
              </div>
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
          </div>
        )}

        {children && <div className="mt-4">{children}</div>}
      </div>
    </header>
  );
}

export default PageHeader;
